import { render, staticRenderFns } from "./UiReportList.vue?vue&type=template&id=58468850&scoped=true&"
import script from "./UiReportList.vue?vue&type=script&lang=js&"
export * from "./UiReportList.vue?vue&type=script&lang=js&"
import style0 from "./UiReportList.vue?vue&type=style&index=0&id=58468850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58468850",
  null
  
)

export default component.exports